import React, { FC, PropsWithChildren } from 'react';
import { View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import TouchableElement from '@components/common/touchableElement';
import { ContainerStyle, SimpleOnPress } from '@interfaces/base';
import { DashboardScope } from '@api/domain/types';

import { getRowContainerStyle } from '@v2/pages/dashboard/common/helpers';
import type { WithBorderRadiusConfig } from '@v2/pages/dashboard/common/types/rows';
import { DASHBOARD_PRESS_HOVER_BG_COLOR } from '@v2/pages/dashboard/common/constants/colors';

export interface DashboardRowWrapperProps
  extends PropsWithChildren,
    WithColor,
    SimpleOnPress,
    ContainerStyle,
    WithBorderRadiusConfig {
  scope: DashboardScope;
  testID: string;
}

const DashboardRowWrapper: FC<DashboardRowWrapperProps> = ({
  C,
  scope,
  borderRadiusConfig,
  onPress,
  containerStyle,
  testID,
  children,
}) => {
  return (
    <TouchableElement testID={testID} onPress={onPress}>
      {({ boxStyle, hovered, pressed, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            getRowContainerStyle(scope, borderRadiusConfig),
            {
              backgroundColor: hovered || pressed ? C(pressHoverColor(DASHBOARD_PRESS_HOVER_BG_COLOR)) : 'transparent',
            },
            containerStyle,
          ]}
        >
          {children}
        </View>
      )}
    </TouchableElement>
  );
};

export default ColorWrapper(DashboardRowWrapper);
